"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BBIndicesEnum = void 0;
var BBIndicesEnum;
(function (BBIndicesEnum) {
    BBIndicesEnum[BBIndicesEnum["TOP_LEFT_X"] = 0] = "TOP_LEFT_X";
    BBIndicesEnum[BBIndicesEnum["TOP_LEFT_Y"] = 1] = "TOP_LEFT_Y";
    BBIndicesEnum[BBIndicesEnum["TOP_RIGHT_X"] = 2] = "TOP_RIGHT_X";
    BBIndicesEnum[BBIndicesEnum["TOP_RIGHT_Y"] = 3] = "TOP_RIGHT_Y";
    BBIndicesEnum[BBIndicesEnum["BOTTOM_RIGHT_X"] = 4] = "BOTTOM_RIGHT_X";
    BBIndicesEnum[BBIndicesEnum["BOTTOM_RIGHT_Y"] = 5] = "BOTTOM_RIGHT_Y";
    BBIndicesEnum[BBIndicesEnum["BOTTOM_LEFT_X"] = 6] = "BOTTOM_LEFT_X";
    BBIndicesEnum[BBIndicesEnum["BOTTOM_LEFT_Y"] = 7] = "BOTTOM_LEFT_Y";
})(BBIndicesEnum || (exports.BBIndicesEnum = BBIndicesEnum = {}));
